
import React from 'react';
import { Leaf } from 'lucide-react';
import { SelectField, SelectOption, ToggleField } from './components';

interface CarbonFootprintTabProps {
  editing: boolean;
}

// Define the component type with an Icon static property
interface CarbonFootprintTabComponent extends React.FC<CarbonFootprintTabProps> {
  Icon: typeof Leaf;
}

const CarbonFootprintTab: CarbonFootprintTabComponent = ({ editing }) => {
  const calculationMethods: SelectOption[] = [
    { value: 'ghg-protocol', label: 'GHG Protocol' },
    { value: 'iso-14064', label: 'ISO 14064' },
    { value: 'pef', label: 'Product Environmental Footprint (PEF)' },
    { value: 'custom', label: 'Custom Method' }
  ];

  const emissionFactors: SelectOption[] = [
    { value: 'epa', label: 'EPA eGRID (USA)' },
    { value: 'defra', label: 'DEFRA (UK)' },
    { value: 'ipcc', label: 'IPCC Global' },
    { value: 'custom', label: 'Custom Factors' }
  ];

  return (
    <div className="grid gap-4">
      <SelectField
        id="carbon-calculation"
        label="Carbon Calculation Method"
        options={calculationMethods}
        defaultValue="ghg-protocol"
        disabled={!editing}
        description="Standard used for carbon footprint calculation"
      />
      
      <SelectField
        id="emission-factor"
        label="Default Emission Factor Source"
        options={emissionFactors}
        defaultValue="epa"
        disabled={!editing}
      />
      
      <ToggleField
        id="scope3"
        label="Include Scope 3 Emissions"
        description="Track indirect emissions from value chain"
        checked={true}
        disabled={!editing}
      />
      
      <ToggleField
        id="real-time"
        label="Real-time Carbon Intensity"
        description="Track carbon intensity from grid in real-time"
        checked={false}
        disabled={!editing}
      />
    </div>
  );
};

// Assign the Icon property
CarbonFootprintTab.Icon = Leaf;

export default CarbonFootprintTab;
